import styled, { css } from 'styled-components'

import { HeaderExtended } from '@awaze/design-system.compositions.responsive-header'

import { onMobile } from '../utils/dimension'

export const StickableHeaderExtended = styled(HeaderExtended)<{
  stuck: boolean
  hasSeparator?: boolean
}>`
  ${onMobile} {
    transition: 300ms padding ease-out;
    ${(p) =>
      p.stuck &&
      css`
        background: #fff;
        border-bottom: ${p.hasSeparator && `1px solid ${p.theme.ColorGrey100}`};
        padding: 0;
      `}
  }
`
